// the Uniswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL =
  'http://kswap.web3s.finance/tokenlist/tokenlist.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]
